export default "__VITE_ASSET__cP_W89Y8__";